import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IClient, ILoginDto } from 'src/app/core/models';
import { CommonConstants } from 'src/app/shared/constant';
import {
  AuthService,
  ClientService,
  ToastService,
} from 'src/app/core/services';

@Component({
  selector: 'ic-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public registrationForm: FormGroup;
  public showPassword: boolean = false;
  public formErrors: any = {};
  public clientConfig: IClient;
  public selectedTab = 1;
  @Input() dialogData: any;

  constructor(
    private readonly fb: FormBuilder,
    private readonly clientService: ClientService,
    private readonly toastService: ToastService,
    private readonly authService: AuthService,
    public readonly activeDialog: NgbActiveModal
  ) {
    this.clientConfig = this.clientService.currentClientValue;
  }

  ngOnInit() {
    this.loginForm = this.fb.group({
      username: [
        '',
        [Validators.required, Validators.maxLength(30), Validators.email],
      ],
      password: ['', [Validators.required, Validators.maxLength(30)]],
    });

    // This forces validation.
    Object.keys(this.loginForm.controls).forEach((key) => {
      this.loginForm.get(key).markAsTouched();
    });

    this.loginForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.loginForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });
  }

  closeDialog() {
    this.activeDialog.close();
  }

  get fc() {
    return this.loginForm.controls;
  }

  login() {
    if (!this.clientConfig || !this.clientConfig?.restaurantId) {
      this.toastService.showInfo('Please wait.. Reloading');
      location.reload();
      return;
    }
    const credentials: ILoginDto = { ...this.loginForm.value };
    credentials.restaurantId = this.clientConfig?.restaurantId.toString();
    credentials.roleId = CommonConstants.Role.Customer.toString();
    credentials.otpLogin = 'false';
    this.authService.login(credentials).subscribe(
      (result) => {
        if (result) {
          this.closeDialog();
        } else {
          this.toastService.showError('Invalid Role Access');
        }
      },
      (err) => {
        this.toastService.showError(
          err.error.error || err.error.error_description
        );
      }
    );
  }

  trimEmail() {
    const val = this.loginForm.get('username').value.trim();
    this.loginForm.get('username').setValue(val);
  }
}
